import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = [];

export default handleActions(
  {
    [Actions.LOAD_DONE]: (_, { payload: { edges } }) => edges,
  },
  initialState,
);
